import React, { Component } from 'react'
import reactCSS from 'reactcss'
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter';
import Slider from '@material-ui/core/Slider';
export default class LineHeightPicker extends Component {
    constructor(props){
        super(props);
        this.state ={
            displayPicker: false,
            align:'left',
            value:this.props.lnHeight
        }
    }
    handleClick = () => {
        this.setState({ displayPicker: !this.state.displayPicker })
      };
    
      handleClose = () => {
        this.setState({ displayPicker: false })
      };
    
    
     handleChange =(event, newValue) =>{
       this.setState({value:newValue}, function() {
        this.props.handleLineHeight(this.state.value);
      });
      }
  render() {
    const styles = reactCSS({
        'default': {
          color: {
            width: '30px',
            height: '5px',
            borderRadius: '2px',
            
          },
          swatch: {
            background: '#fff',
            borderRadius: '1px',
            display: 'inline-block',
            cursor: 'pointer',
            textAlign:'center',
            border:'none',
            position:'relative'
          },
          popover: {
            marginTop:'10px',
            position: 'absolute',
            zIndex: '2',
            backgroundColor:'whitesmoke',
            minWidth:'120px',
            padding:'5px 5px 3px 5px',
            boxShadow:'2px 2px 15px rgb(0 0 0 / 10%)'
          },

          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            zIndex:-1
          },
        },
      });

      return (
        <div>
          <div style={ styles.swatch } onClick={ this.handleClick }>
            
        
                <VerticalAlignCenterIcon style={{fontSize:'20px'}}/> <span className='lhValue'>{this.state.value}px</span>
                
                
           
           
          </div>
          { this.state.displayPicker ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
            <div className='popBox'>
            <Slider value={this.state.value} onChange={this.handleChange} aria-labelledby="continuous-slider" />
            {/* <ReactSlider
                min={0}
                max={100}
                className="horizontal-slider"
                thumbClassName="lineHeight-thumb"
                trackClassName="lineHeight-track"
                defaultValue={this.props.lnHeight}
                onAfterChange={(props, state) => this.handleChange(state)}
                renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
            /> */}
            </div>
          
          </div> : null }
  
        </div>
      )
    }
  
}
